jQuery(document).ready(function($) {
	$(document).on('click', '.tabs-title a', function(e) {
		e.preventDefault();
		var tab = $(this).attr('href');
		$('.tabs-title').removeClass('is-active');
		$(this).parent().addClass('is-active');
		$('.tabs-panel').removeClass('is-active');
		$(tab).addClass('is-active');
	});
	
	// handle navigation between tabs
	$('.tabs-navigation .previous').on('click', function() {
		$('.tabs .is-active').prev('li').find('a').trigger('click');
	});
	$('.tabs-navigation .next').on('click', function() {
		$('.tabs .is-active').next('li').find('a').trigger('click');
	});

	// scroll horizontally to the active tab
	$('.tabs-navigation .previous, .tabs-navigation .next').on('click', function() {
		var $tabsWrapper = $('.tabs-wrapper');
		var $tabs = $('.tabs');
		var $activeTab = $('.tabs .is-active');
		
		var $tabsBeforeActive = 0;
		$activeTab.prevAll().each(function() {
			$tabsBeforeActive += $(this).outerWidth();
		});
		
		$tabsWrapper.animate({
			scrollLeft: $tabsBeforeActive
		}, 100);
		
	});
	
});
